import classNames from "classnames";
import React, { useEffect } from "react";
import { useFormContext } from "react-hook-form";

import { getVal } from "../../helpers/getVal";
import "./FormInput.less";

const errorsMap = {
  minLength: "Значение не соответствует минимальной длине",
};

export const FormInput = ({
  id,
  titleText,
  validation,
  children,
  next,
  hideValidation = false,
  validationSelect = false,
  validationDate = false,
  warning = "",
  className = "",
  onFocusNext = undefined,
}) => {
  let focusNext = null;
  let validationError = null;

  // react-hook-form support
  let valid = validation?.valid;
  if (valid === undefined) {
    if (!validation?.error) {
      valid = !validation?.isTouched ? undefined : true;
    } else {
      valid = false;
    }
  }

  let error = validation?.error;
  if (typeof error === "object") {
    error = validation?.error?.message || errorsMap[validation?.error?.type];
  }

  const context = useFormContext();

  if ((!validation || Object.keys(validation).length === 0) && context) {
    const {
      setFocus,
      watch,
      formState: { errors },
    } = context;
    const value = watch(id);
    validationError = getVal(errors, id);
    if (validationError === undefined) {
      const val = typeof value === "object" ? value?.text : value;
      valid = !val ? undefined : true;
    } else {
      valid = false;
    }
    error = validationError?.message || errorsMap[validationError?.type];
    focusNext = () => {
      if (validationError || !valid || !value) return;
      if (next && value) setTimeout(() => setFocus(next)); // setTimeout - iOS fix
      if (onFocusNext) onFocusNext(id, value);
    };
  }

  useEffect(() => {
    if (focusNext) focusNext(next);
  }, [validationError]);

  return (
    <li
      className={classNames(
        "item test",
        "auto-complete",
        { [className]: className },
        {
          success: !hideValidation && valid === true, // must not be null (null if not validated yet)
          error: !hideValidation && valid === false, // must not be null (null if not validated yet)
          validationSelect,
          validationDate,
        }
      )}>
      <div className="form-group form-input">
        {children}
        <label className="form-input__label" htmlFor={id}>
          {titleText}
        </label>
      </div>
      {valid === false && <div className="error-text">{error}</div>}
      {warning && (
        <div className="error-text error-text--inform">{warning}</div>
      )}
    </li>
  );
};
